import {logOut,getUserData} from '../../../redux/actions';
import {Link} from 'react-router-dom'
import './Navbar.css';
import logo from '../../../img/logoDM.svg';
import logout from '../../../img/logout.png';
import React, {useEffect} from 'react';
import {useSelector,useDispatch} from 'react-redux';
import { useNavigate, useLocation} from "react-router-dom";
import { jwtDecode } from 'jwt-decode'; 

 const Navbar=()=>{
    const navigate = useNavigate();
    const location = useLocation();
    const error = useSelector((state) => state.auth.error);
    const role = useSelector((state) => state.userdata?.role);
    const token = useSelector((state) => state.auth.token) || localStorage.getItem('token');
    const username = useSelector((state) => state.userdata?.username);
    const showBtnLk = location.pathname === "/";
    const dispatch = useDispatch();

// Функция для проверки срока действия токена
    const isTokenExpired = (token) => {
        try {
            const decoded = jwtDecode(token);
            return decoded.exp < Date.now() / 1000;
        } catch (e) {
            return true; // Если токен невалидный, считаем его просроченным
        }
    };

    useEffect(() => {
        // Проверяем токен при каждом рендере
        if (!token || isTokenExpired(token)) {
            localStorage.removeItem('token');
             dispatch(logOut());
            return;
        }
       }, [token, navigate]);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                await dispatch(getUserData()); 
            } catch (error) { console.error('Error fetching user data:', error);}
        };
        fetchUserData();
    }, [dispatch, token, role, error, username]);

    const handleClickOut = () => {
        dispatch(logOut());
    };
    const handleClickLk = (e) => {
        e.preventDefault();
        const link= "/devices";
        navigate(link);
    };

    return(
        <div className='navbar'>
                <Link to="/" className='navbarLogo'> 
                    <img src={logo} alt="Result" className='navbarLogoImg'/> 
                     <h3>dm-control.ru</h3>
                </Link>
            <div className='navbarBlock'>
            {role ? (
            <>  
                <div className='navbarInfo'> 
                    <div className='navbarInfoRole'>
                        <h4>{role===1 ? 'Администратор:' : 'Пользователь:'}</h4>
                    </div>
                    <div className='navbarInfoUsername'>                       
                        {username}
                    </div> 
                </div> 
             {showBtnLk && <button className='navbarBtnLK' onClick={handleClickLk}>ЛК</button>}    
                 <div className='navbarOut'> 
                    <button className='navbarBtnOut' onClick={handleClickOut}>
                        <img src={logout} alt="Result" className='navbarLogout'/> 
                    </button>
                </div>  
            </>     
             ) : ( 
                <Link to="/login" className='navbarLkIn'>Вход</Link>
            ) }
            </div>
        </div>
    )
}
export default Navbar;
